import { FC, Suspense } from 'react'
import { t } from '@lingui/macro'
import clsx from 'clsx'
import { NavLink, useParams } from 'react-router-dom'
import { EROUTER_HISTORY_PARAMS, urls } from '@/router/urls'
import { Loader } from '@/ui/kit/Loader'
import styles from './styles.module.scss'
import { useActiveExchage } from '@/utils/hooks/useActiveExchange'
import { HistoryTrade } from './components/HistoryTrade/HistoryTrade'
import { HistoryTransactions } from './components/HistoryTransactions/HistoryTransactions'
import { ConvertHistory } from './components/ConvertHistory/ConvertHistory'

export type HistoryStateType = {
  isProfileRedirect?: boolean
}

export const History: FC = () => {
  const { historyType } = useParams()
  const { activeExchange } = useActiveExchage()

  const historyConfig = activeExchange.pages.history

  const tabs = [
    {
      id: EROUTER_HISTORY_PARAMS.trade,
      label: t({ id: 'historyTrade.title', comment: 'Exchange trading history' }),
      to: urls.historyTrade,
      component: <HistoryTrade />,
      isAvailable: historyConfig.trade,
    },
    {
      id: EROUTER_HISTORY_PARAMS.transactions,
      label: t({ id: 'historyTransactions.title', comment: 'Transactions history' }),
      to: urls.historyTransactions,
      component: <HistoryTransactions />,
      isAvailable: historyConfig.transactions.isAvailable,
    },
    {
      id: EROUTER_HISTORY_PARAMS.convert,
      label: t({ id: 'historyConvert.title', comment: 'Convert history' }),
      to: urls.historyConvert,
      component: <ConvertHistory />,
      isAvailable: historyConfig.convert,
    },
  ]

  const visibleTabs = tabs.filter(tab => tab.isAvailable)
  const activeTab = visibleTabs.find(tab => tab.id === historyType)

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        {visibleTabs.map(tab => (
          <NavLink
            key={tab.id}
            to={tab.to}
            className={({ isActive }) => clsx(styles.title, { [styles.active]: isActive })}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      {activeTab && <Suspense fallback={<Loader />}>{activeTab.component}</Suspense>}
    </div>
  )
}
